import React from "react";

export const HeartIcon = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.4755 0.454102C10.6708 0.454102 9.93309 0.709085 9.28284 1.21198C8.65942 1.69412 8.24437 2.3082 8.00001 2.75474C7.75566 2.30817 7.3406 1.69412 6.71719 1.21198C6.06693 0.709085 5.32921 0.454102 4.52455 0.454102C2.27905 0.454102 0.585693 2.2908 0.585693 4.72643C0.585693 7.35776 2.69828 9.15808 5.89646 11.8835C6.43956 12.3464 7.05515 12.871 7.69498 13.4305C7.77932 13.5043 7.88764 13.545 8.00001 13.545C8.11239 13.545 8.22071 13.5043 8.30504 13.4305C8.94493 12.8709 9.5605 12.3463 10.1039 11.8832C13.3017 9.15808 15.4143 7.35776 15.4143 4.72643C15.4143 2.2908 13.721 0.454102 11.4755 0.454102Z"
      />
  </svg>
)
